"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyValList = void 0;
class KeyValList {
    constructor() {
        this._keyValList = new Array();
    }
    get keyValList() { return this._keyValList; }
    set keyValList(keyValList) { this._keyValList = keyValList; }
    add(key, val) {
        const keyVal = { key: key, val: val };
        this._keyValList.push(keyVal);
        return keyVal;
    }
    getByKey(key) {
        const item = this._keyValList.find((keyVal) => keyVal.key === key);
        if (!item) {
            console.log("Item not found by key: " + key);
            return null;
        }
        return item;
    }
    getByVal(val) {
        const item = this._keyValList.find((keyVal) => keyVal.val === val);
        if (!item) {
            console.log("Item not found by val: " + val);
            return null;
        }
        return item;
    }
    removeByKey(key) {
        const idx = this._keyValList.findIndex((keyVal) => keyVal.key === key);
        if (idx === -1) {
            console.log("Item not found by key: " + key);
            return null;
        }
        return this._keyValList.splice(idx, 1);
    }
    removeByVal(val) {
        const idx = this._keyValList.findIndex((keyVal) => keyVal.val === val);
        if (idx === -1) {
            console.log("Item not found by val: " + val);
            return null;
        }
        return this._keyValList.splice(idx, 1);
    }
}
exports.KeyValList = KeyValList;
